import * as React from 'react';
import { SVGProps } from 'react';

const IconEditSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m14 5-3-3-1.414 1.414 3 3L14 5zm-2.121 2.121-3-3L2 11v3h3l6.879-6.879z" />
  </svg>
);
export default IconEditSizeS;
